import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule, MatProgressSpinnerModule } from "@angular/material";
import { CommonSectionsModule } from "../../../../../views/common/common-sections.module";
import { TooltipModule } from "../../../../../tooltip/tooltip.module";
import { IndianCurrencyFormatterModule } from "../../../../../views/common/indian-currency-formatter/indian-currency-formatter.module";
import { FundAllocationComponent } from "./fund-allocation/fund-allocation.component";
import { PortfolioCreationComponent } from "./portfolio-creation.component";
import { PortfolioCreationRoutingModule } from "./portfolio-creation.routing.module";
import { ProductResolver } from "../../../../../resolvers/product.resolver";
import { LenderBasicInfoResolver } from "../../../../../resolvers/lender-info.resolver";
import { ProductsInvestAmountComponent } from "./products-invest-amount/products-invest-amount.component";
import { AllocationErrorPopupComponent } from "./allocation-error-popup/allocation-error-popup.component";
import { PortfolioCreationSuccessfulComponent } from "./portfolio-creation-successful/portfolio-creation-successful.component";
import { PortfolioCreationFailureComponent } from "./portfolio-creation-failure/portfolio-creation-failure.component";
import { AutoPortfolioAllocationComponent } from "./auto-portfolio-allocation/auto-portfolio-allocation.component";
import { FiftyLakhsErrorPopupComponent } from "./fifty-lakhs-error-popup/fifty-lakhs-error-popup.component";
import { FlexInvestmentAmountResolver } from "../../../../../resolvers/flexInvestmentAmount.resolver";
import { MaxInvestmentAmountResolver } from "../../../../../resolvers/maxInvestmentAmount.resolver";

@NgModule({
    declarations: [
        PortfolioCreationComponent,
        FundAllocationComponent,
        ProductsInvestAmountComponent,
        AutoPortfolioAllocationComponent,
        AllocationErrorPopupComponent,
        PortfolioCreationSuccessfulComponent,
        PortfolioCreationFailureComponent,
        FiftyLakhsErrorPopupComponent
    ],
    imports: [
        CommonModule,
        CommonSectionsModule,
        IndianCurrencyFormatterModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        TooltipModule,
        PortfolioCreationRoutingModule,
        MatProgressSpinnerModule
    ],
    providers: [ProductResolver, LenderBasicInfoResolver, FlexInvestmentAmountResolver, MaxInvestmentAmountResolver]
})
export class PortfolioCreationModule {}